import React from "react"
import { Box, Typography } from "@mui/material"
import { useStyles } from "./styles"

interface Props {
  isVisible?: boolean
  onClick?: () => void
  onKeyUp?: (e: React.KeyboardEvent<HTMLLIElement>) => void
}

const SkipLink = React.forwardRef<
  HTMLAnchorElement,
  React.PropsWithChildren<Props>
>(({ isVisible = false, onClick, onKeyUp, children }, ref) => {
  const { classes } = useStyles({ isVisible })

  const focusLink = (e: React.FocusEvent<HTMLLIElement, Element>) => {
    e.target.setAttribute("style", "opacity: 100% ; z-index: 9999;")
  }

  const blurLink = (e: React.FocusEvent<HTMLLIElement, Element>) => {
    e.target.setAttribute("style", "opacity: 0% ; z-index: -9999;")
  }

  return (
    <Box
      ref={ref}
      tabIndex={0}
      component="li"
      className={classes.link}
      onFocus={focusLink}
      onBlur={blurLink}
      onClick={onClick}
      onKeyUp={onKeyUp}
    >
      <Typography variant="h4" component="a">
        {children}
      </Typography>
    </Box>
  )
})

export default SkipLink
